import {documentTypes} from './config'
import DocumentListRenderer from '../components/block/DocumentListRenderer'
import Contact from '../components/block/Contact'

const blockTypes = {
	hero: {
		name: 'Hero',
		fields: [
		{
			name: 'size',
			type: 'radio',
			values: [
				{
					val: 'full',
					label: 'Intreg ecranul'
				},
				{
					val: 'bg-prop',
					label: 'Proportional'
				},
				{
					val: 'slim',
					label: 'Slim'
				},
			],
			label: 'Mărime',
			prepare: (config) => {
				if(config.block.size) config.classes.push(config.block.size)
				else config.classes.push('slim')
				return config
			}
		},
		{
			name: 'img',
			type: 'img',
			label: 'Imagine',
			single: false,
			render: null,
			prepare: (config) => {
				if (config.entity && config.entity.header && config.entity.header.length>0) config.bg = config.entity.header
				if (!config.bg && config.entity && config.entity.gallery && config.entity.gallery.length>0) config.bg = config.entity.gallery
				if (!config.bg && config.block.img && config.block.img.length>0) config.bg = config.block.img
				config.bgStyle = 'hero'
				config.transitionBg = true
				return config
			}
		},
		]
	},
	doclist: {
		name: 'Document List',
		renderer: DocumentListRenderer,
		fields: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			t:true
		},
		{
			name: 'kind',
			type: 'select',
			values: documentTypes,
			label: 'Tip'
		},
			
		]
	},
	contact: {
		name: 'Contact',
		renderer: Contact
	}
}
const blockRenderers = {
	
}
export {blockTypes, blockRenderers}




// WEBPACK FOOTER //
// ./src/conf/block.js